import type { Rule } from 'antd/es/form';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const usePasswordAsCurrentPasswordRule = () => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      ({ getFieldValue }: { getFieldValue: (field: string) => string }) => ({
        message: t('Error: New password must be different from the current password.'),
        // eslint-disable-next-line @typescript-eslint/require-await -- Antd interface need async validator
        async validator(_: Rule, value: string) {
          const currentPassword = getFieldValue('currentPassword');

          if (value && currentPassword && currentPassword === value) {
            throw new Error(t('Error: New password must be different from the current password.'));
          }
        },
      }),
    [t],
  );
};
